export default __webpack_public_path__ + "locales/ro/DataReassignmentDialog.json?hash=9967c61d49ce0632b15c20da18d246f2";